import React, { useState } from 'react';
import { MenuIcon, XIcon, PhoneIcon } from 'lucide-react';
import { CONTACT, LOGO } from '../data/copy';
import { useLanguage } from '../contexts/LanguageContext';
import { LanguageToggle } from './LanguageToggle';
export function Navbar() {
  const {
    t
  } = useLanguage();
  const [open, setOpen] = useState(false);
  return <header className="fixed inset-x-0 top-0 z-40 bg-white" style={{
    boxShadow: '0 2px 8px rgba(0,0,0,0.10)'
  }} data-id="element-151" data-mp="sbcbkx8wm7b5">
      <div className="mx-auto flex h-20 max-w-7xl items-center justify-between gap-6 px-5 lg:px-8" data-id="element-152" data-mp="4n1em56bwrs5">
        <a href="#top" className="flex items-center" data-id="element-153" data-mp="eje9359p79ny">
          <img src="https://i.imgur.com/Wx3mHZ2.png" alt={LOGO.alt} className="h-16 w-auto object-contain" data-id="element-154" data-mp="ek779hulcquh" />
        </a>

        <nav aria-label={t.nav.ariaMain} className="hidden items-center gap-8 lg:flex" data-id="element-155" data-mp="1py1j1mmdlc4e">
          {t.nav.links.map(link => <a key={link.href} href={link.href} className="whitespace-nowrap text-sm font-semibold text-forest transition-colors duration-150 ease-out hover:text-rust" data-id="element-156" data-mp="1kyonmdhfuwq7">
              {link.label}
            </a>)}
        </nav>

        <div className="hidden items-center gap-4 lg:flex" data-id="element-157" data-mp="jnyp613phtmf">
          <a href={CONTACT.phoneHref} className="flex items-center gap-2 whitespace-nowrap text-sm font-bold text-forest transition-colors duration-150 ease-out hover:text-rust" data-id="element-158" data-mp="olgp51zqwyia">
            <PhoneIcon className="h-4 w-4 text-forest" aria-hidden="true" data-id="element-159" data-mp="3s1xggpfqgqtl" />
            {CONTACT.phone}
          </a>
          <LanguageToggle data-id="element-160" data-mp="v4hls8ex3s8" />
          <a href="#contact" className="whitespace-nowrap rounded-md bg-rust px-5 py-3 text-sm font-bold text-white transition-colors duration-150 ease-out hover:bg-rust-dark" data-id="element-161" data-mp="uutka6xh6p6">
            {t.nav.cta}
          </a>
        </div>

        <div className="flex items-center gap-3 lg:hidden" data-id="element-162" data-mp="39axodfcxz0w3">
          <LanguageToggle data-id="element-163" data-mp="31b9uuim4h431" />
          <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-label={open ? t.nav.closeMenu : t.nav.openMenu} className="rounded-md p-2 text-forest transition-colors duration-150 ease-out hover:bg-forest/5" data-id="element-164" data-mp="31ahxp3cvmyan">
            {open ? <XIcon className="h-6 w-6" aria-hidden="true" data-id="element-165" data-mp="362i3hcfmolf5" /> : <MenuIcon className="h-6 w-6" aria-hidden="true" data-id="element-166" data-mp="2idgthkr5d27r" />}
          </button>
        </div>
      </div>

      {open && <div className="border-t border-neutral-200 bg-white px-5 pb-6 pt-2 lg:hidden" data-id="element-167" data-mp="2dff5clev6cpf">
          <nav aria-label={t.nav.ariaMobile} className="flex flex-col" data-id="element-168" data-mp="2sbwfxaf8bnax">
            {t.nav.links.map(link => <a key={link.href} href={link.href} onClick={() => setOpen(false)} className="border-b border-neutral-200 py-3 text-base font-semibold text-forest" data-id="element-169" data-mp="2nduzkx96u235">
                {link.label}
              </a>)}
          </nav>
          <a href="#contact" onClick={() => setOpen(false)} className="mt-5 block rounded-md bg-rust px-5 py-3 text-center text-sm font-bold text-white" data-id="element-170" data-mp="f3lu7pmpgw9j">
            {t.nav.cta}
          </a>
        </div>}
    </header>;
}